export class FinancialDataErrorResponse {
  valueEnteredIn: any;
}
